import type { IMenuStore } from '~/modules/main'

export const state = (): IMenuStore => {
  return {
    profile: null,
    isProfileLoading: false,
    hasProfileError: false,
  }
}
